import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';


const brandPrimary = {
  50: '#FCEEF4',
  100: '#F8DBE7',
  200: '#F0AECC',
  300: '#E282B3',
  400: '#D24F95',
  500: '#8E2060',
  600: '#761A50',
  700: '#5E1540',
  800: '#460F30',
  900: '#2E0A20',
  950: '#170510',
};

export const CardioExplorerPreset = definePreset(Lara, {
  semantic: {
    primary: brandPrimary,
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.500}',
          focusBackground: '{primary.600}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        formField: {
          focusBorderColor: '{primary.500}',
          focusRing: {
            width: '1px',
            style: 'solid',
            color: '{primary.500}',
            offset: '0',
            shadow: '0 0 0 1px {primary.500}',
          },
        },
      },
    },
  },
  components: {
    datatable: {
      colorScheme: {
        light: {
          header: { background: '#ffffff' },
          headerCell: { background: '#ffffff', hoverBackground: '{surface.50}' },
        },
      },
    },
    paginator: {
      navButton: {
        width: '3rem',
        height: '3rem',
      },
    },
  },
});
